import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68d569ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper-profile-header" }
const _hoisted_2 = {
  key: 0,
  class: "date-grid"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Created on:", -1))
const _hoisted_4 = { class: "value" }
const _hoisted_5 = {
  key: 1,
  class: "date-grid"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Last seen on:", -1))
const _hoisted_7 = { class: "value" }
const _hoisted_8 = { class: "modal-container" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "footnote" }, "Username must be longer than 6 characters", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProfileProfilePicture = _resolveComponent("ProfileProfilePicture")!
  const _component_ModalView = _resolveComponent("ModalView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.profilePictureEditable ? (_ctx.isOpen = true) : null))
    }, _toDisplayString(_ctx.contextUser.displayName), 1),
    _createElementVNode("div", null, [
      (_ctx.creationDateFormatted !== '')
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.creationDateFormatted), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.lastSeenDateFormatted !== '')
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.lastSeenDateFormatted), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ProfileProfilePicture, {
      editable: _ctx.profilePictureEditable,
      "profile-picture": _ctx.contextUser.profilePicture
    }, null, 8, ["editable", "profile-picture"]),
    _createVNode(_component_ModalView, {
      "is-open": _ctx.isOpen,
      onOnCloseClicked: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isOpen = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: "Enter a new username",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.nUsername) = $event))
          }, null, 512), [
            [_vModelText, _ctx.nUsername]
          ]),
          _hoisted_9,
          _createElementVNode("input", {
            type: "submit",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.updateUsername && _ctx.updateUsername(...args))),
            class: _normalizeClass(
            _ctx.nUsername === _ctx.contextUser.displayName || _ctx.nUsername.length <= 6
              ? 'disabled'
              : ''
          )
          }, null, 2)
        ])
      ]),
      _: 1
    }, 8, ["is-open"])
  ]))
}